import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  EmployeeOnBoard,
  EmployeeOnBoardResponse,
  IEmployeeDetailsResponse,
  IUserListResponse,
} from "@/interface/employeeOnBoard";

const EmployeeOnBoardService = {
  createEmployee: async (
    payload: EmployeeOnBoard,
  ): Promise<EmployeeOnBoardResponse> => {
    const API = `${API_ENDPOINT.user}/onboard`;
    return callApi<EmployeeOnBoardResponse>(API, {
      method: "POST",
      data: payload,
    });
  },
  editEmployee: async (
    payload: Partial<EmployeeOnBoard>,
    id: string,
  ): Promise<EmployeeOnBoardResponse> => {
    const API = `${API_ENDPOINT.user}/${id}`;
    return callApi<EmployeeOnBoardResponse>(API, {
      method: "PUT",
      data: payload,
    });
  },
  getAllEmployees: async (): Promise<IUserListResponse> => {
    const API = `${API_ENDPOINT.user}/get-employee`;
    return callApi<IUserListResponse>(API, { method: "GET" });
  },
  getEmployeeById: async (id: string): Promise<IEmployeeDetailsResponse> => {
    const API = `${API_ENDPOINT.user}/${id}`;
    return callApi<IEmployeeDetailsResponse>(API, { method: "GET" });
  },
};

export default EmployeeOnBoardService;
